import { Pipe, PipeTransform } from '@angular/core';
import { InsurerMeta } from '@lockton-apps/shared/interfaces';
import { InsurerMetaService } from '@lockton-apps/shared/util/constants';

@Pipe({
  name: 'quoteInsurerMeta',
  standalone: true,
})
export class QuoteInsurerMetaPipe implements PipeTransform {
  constructor(private readonly insurerMetaService: InsurerMetaService) {}

  transform(
    insurer: number,
    portalId: number,
    cob: number
  ): Partial<InsurerMeta> {
    return this.insurerMetaService.get(insurer, portalId, cob);
  }
}
